<template>
  <div class="rounded-container" v-on:click="onPress">
    <span v-if="this.text" class="text-rounded">{{ this.text }}</span>
    <img v-else :src="loadMyAccount" class="icon" :alt="$t('alt.mon.compte')"/>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: 'RoundedIconAndText',
    props: {
        text: String,
        onPress: { type: Function as PropType<() => void> }
    },
    computed:{
        loadMyAccount(){
            return require('@/assets/img/menu/person.png');
        }
    }
});
</script>

<style scoped>
.icon {
  height: 30px;
  display: block;
}
.rounded-container {
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
}
.text-rounded{
  color: var(--white);
  font-size: var(--font-size-high-medium);
  font-size: var(--font-size-small);
}
</style>
